document.addEventListener("DOMContentLoaded", () => {
    const section = document.querySelector(".js-product-grid");
    if (!section) return;

    section.addEventListener("click", (event) => {
        const button = event.target.closest(".js-product-grid-card-subscription, .js-product-grid-card-one-time");
        if (!button) return;

        const item = {
            id: Number(button.dataset.variantId),
            quantity: 1
        };

        if (button.matches(".js-product-grid-card-subscription")) {
            item.selling_plan = Number(button.dataset.sellingPlanId);
        }

        VueMinicart.config.globalProperties.$store.dispatch("addItem", item);
    });
});